import styled from "styled-components";
import type {CSSProperties} from "react";
import {useEffect, useRef, useState} from "react";
import {LoaderIconV5} from "./ui/5.0/loader/LoaderIconV5";
import {radius, zIndex} from "./ui/5.0/styles/styles";
import {ReactUtils} from "./ui/utils/ReactUtils";

interface IFullscreenLoaderProps {
	readonly text: string;
	readonly style?: CSSProperties;
}

export const FullscreenLoader = (props: IFullscreenLoaderProps) => {
	const {text, style = {}} = props;
	const [isVisible, setIsVisible] = useState<boolean>(false);
	const timeoutRef = useRef<number>(-1);

	useEffect(() => {
		clearTimeout(timeoutRef.current);
		timeoutRef.current = window.setTimeout(() => setIsVisible(!!text), 40);
	}, [text]);

	return (
		text && (
			<ShadowDivStyled
				className={ReactUtils.cls({isVisible})}
				style={{display: "flex", justifyContent: "center", alignItems: "center", ...style}}
			>
				<LoaderWrapper>
					<LoaderIconV5 />
					{text}
				</LoaderWrapper>
			</ShadowDivStyled>
		)
	);
};

const ShadowDivStyled = styled.div`
	width: 100vw;
	height: 100vh;
	position: fixed;
	top: 0;
	left: 0;
	background-color: rgba(0, 0, 0, 0.4);
	z-index: ${zIndex.shadowDiv};
	transition: opacity ease-in-out 0.3s;
	opacity: 0;
	&.isVisible {
		opacity: 1;
	}
`;

const LoaderWrapper = styled.div`
	display: flex;
	gap: 8px;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	color: white;
	border-radius: ${radius.md};
	padding: 16px;
	background-color: rgba(0, 0, 0, 0.35);
`;
